import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { IconChevronRight } from '@tabler/icons-react';
import empoweringbg from '../images/empowering-card-item1.svg';
import notifeebg from '../images/notifee-card-bg.svg';
import melosbg from '../images/melos-card-bg.svg';
import staricon from '../images/card-star-card.svg';
import assembliesbg from '../images/react-native-google-mobile-ads-bg.svg';
import precision from '../images/precision-mold-components.svg';
import tooling from '../images/custom-tooling-solutions.svg';
import advancedfixtures from '../images/advanced-fixtures.svg';
import machinepart from '../images/machine-part.svg';

const App = () => {
    return (
        <div className="relative w-full overflow-hidden">
            <div className="pl-6 lg:pl-10 pr-0">
                <Swiper
                    spaceBetween={16}
                    freeMode={true}
                    pagination={{ clickable: true }}
                    breakpoints={{
                        0: { slidesPerView: 1.2 },
                        640: { slidesPerView: 2 },
                        1024: { slidesPerView: 3.5 },
                    }}
                    modules={[FreeMode]}
                    className="mt-6 lg:mt-10"
                >
                    <SwiperSlide>
                        <div
                            style={{ backgroundImage: `url(${empoweringbg})` }}
                            className='px-5 py-5 rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer '
                        >
                            <h3 className="text-white lg:text-xl text-lg font-semibold flex gap-1 items-center">
                                <img src={staricon} alt="" className="h-6 w-auto" loading="lazy" />
                                3.2K industry recognition
                            </h3>
                            <div className='flex justify-center'>
                                <img src={precision} alt="" className="w-[100px] card-item-img" loading="lazy" />
                            </div>
                            <div>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>
                                    Precision Mold Components
                                    <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-300 ease-in-out">
                                        <IconChevronRight size={20} stroke={2} />
                                    </span>
                                </h3>
                                <p className='text-[rgb(171,174,187)] font-normal'>
                                    Crafting high-accuracy mold parts like cavity blocks and rotary molds for demanding applications.
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div
                            style={{ backgroundImage: `url(${notifeebg})` }}
                            className='px-5 py-5 rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer'
                        >
                            <h3 className="text-white lg:text-xl text-lg font-semibold flex gap-1 items-center">
                                <img src={staricon} alt="" className="h-6 w-auto" loading="lazy" />
                                2.5K tooling excellence
                            </h3>
                            <div className='flex justify-center'>
                                <img src={tooling} alt="" className="w-[100px] card-item-img" loading="lazy" />
                            </div>
                            <div>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>
                                    Custom Tooling Solutions
                                    <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-300 ease-in-out">
                                        <IconChevronRight size={20} stroke={2} />
                                    </span>
                                </h3>
                                <p className='text-[rgb(171,174,187)] font-normal'>
                                    Carbide tooling, cutting blades, stripper blocks, and more—designed for durability and consistency.
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div
                            style={{ backgroundImage: `url(${melosbg})` }}
                            className='px-5 py-5 rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer'
                        >
                            <h3 className="text-white lg:text-xl text-lg font-semibold flex gap-1 items-center">
                                <img src={staricon} alt="" className="h-6 w-auto" loading="lazy" />
                                1.9K tailored builds
                            </h3>
                            <div className='flex justify-center'>
                                <img src={advancedfixtures} alt="" className="w-[100px] card-item-img" loading="lazy" />

                            </div>
                            <div>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>
                                    Advanced Fixtures & Jigs
                                    <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-300 ease-in-out">
                                        <IconChevronRight size={20} stroke={2} />
                                    </span>
                                </h3>
                                <p className='text-[rgb(171,174,187)] font-normal'>
                                    Purpose-built fixtures and jigs that streamline production and improve efficiency.
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide>
                        <div
                            style={{ backgroundImage: `url(${assembliesbg})` }}
                            className='px-5 py-5 rounded-2xl h-[328px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer'
                        >
                            <h3 className="text-white lg:text-xl text-lg font-semibold flex gap-1 items-center">
                                <img src={staricon} alt="" className="h-6 w-auto" loading="lazy" />
                                1.2K complex assemblies
                            </h3>
                            <div className='flex justify-center'>
                                <img src={machinepart} alt="" className="w-[100px] card-item-img" loading="lazy" />
                            </div>
                            <div>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>
                                    High-Precision Machine Parts
                                    <span className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-300 ease-in-out">
                                        <IconChevronRight size={20} stroke={2} />
                                    </span>
                                </h3>
                                <p className='text-[rgb(171,174,187)] font-normal'>
                                    Fabrication of tape buffers, handlers, and engineering machine parts to exact specifications.
                                </p>
                            </div>
                        </div>
                    </SwiperSlide>


                </Swiper>
            </div>
        </div>
    );
};

export default App;
